(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.lp-pdp-engraved-locket');
    if (!section) return;

    const KLAVIYO_REVISION = '2026-01-15';
    // Support default form (#lp-submit-btn), personalize btn ([data-js-personalize-btn]), and other forms ([data-lpBisNotify])
    let pdpBtn = section.querySelector('#lp-submit-btn');
    if (!pdpBtn) {
      pdpBtn = section.querySelector('[data-js-form-atc], [data-js-drawer-atc]');
    }
    if (!pdpBtn) {
      pdpBtn = section.querySelector('[data-js-personalize-btn]');
    }
    const modal = section.querySelector('#lp-bis-modal');
    if (!pdpBtn || !modal) return;

    const companyId = (section.dataset.klaviyoCompanyId || '').replace(/\s+/g, '');
    const listId = (section.dataset.klaviyoMarketingListId || '').replace(/\s+/g, '');
    const overlay = section.querySelector('#lp-bis-overlay');
    const closeBtn = section.querySelector('#lp-bis-close');
    const form = section.querySelector('#lp-bis-form');
    const emailIn = section.querySelector('#lp-bis-email');
    const submitBtn = section.querySelector('#lp-bis-submit');
    const submitBtnOriginalText = submitBtn ? submitBtn.textContent.trim() : 'NOTIFY ME';
    const errEl = section.querySelector('#lp-bis-err');
    const successEl = section.querySelector('#lp-bis-success');
    const marketingCb = section.querySelector('#lp-bis-marketing');

    function currentVariant() {
      const sel = section.querySelector('[name="id"]');
      const el = section.querySelector('#lp-variant-data');
      if (!sel || !el) return null;
      let data;
      try { data = JSON.parse(el.textContent); } catch (e) { return null; }
      return data.find(v => String(v.id) === String(sel.value)) || null;
    }

    function showErr(msg) {
      if (!errEl) return;
      errEl.textContent = msg || '';
      errEl.hidden = !msg;
    }

    function showSuccess() {
      if (form) form.hidden = true;
      if (successEl) successEl.hidden = false;
      setTimeout(closeModal, 1500);
    }

    function openModal() {
      const v = currentVariant();
      if (!v || v.available) return;
      showErr('');
      if (form) form.reset();
      if (marketingCb) marketingCb.checked = true;
      if (!companyId) showErr('Add your Klaviyo public API key in the PDP section settings.');
      if (submitBtn) submitBtn.disabled = !companyId;
      modal.classList.add('lp-pdp__guidelines-modal--active');
      modal.removeAttribute('inert');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (emailIn && companyId) emailIn.focus();
    }

    function closeModal() {
      modal.classList.remove('lp-pdp__guidelines-modal--active');
      modal.setAttribute('inert', '');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      showErr('');
      if (form) { form.reset(); form.hidden = false; }
      if (successEl) successEl.hidden = true;
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtnOriginalText;
      }
    }

    function klaviyoPost(path, body) {
      const headers = new Headers();
      headers.set('Content-Type', 'application/vnd.api+json');
      headers.set('revision', KLAVIYO_REVISION);
      return fetch(
        'https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(companyId),
        { method: 'POST', headers, body: JSON.stringify(body) }
      );
    }

    pdpBtn.addEventListener('click', (e) => {
      if (pdpBtn.dataset.lpBisNotify === 'true') {
        e.preventDefault();
        e.stopPropagation();
        openModal();
      }
    });
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (overlay) overlay.addEventListener('click', closeModal);

    if (!form || !emailIn || !submitBtn) return;

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (!companyId) return;
      const v = currentVariant();
      if (!v || v.available) return;
      const email = (emailIn.value || '').trim();
      if (!email || !emailIn.checkValidity()) { emailIn.reportValidity(); return; }

      const bisBody = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email } } },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + String(v.id) } },
          },
        },
      };

      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending\u2026';
      showErr('');

      klaviyoPost('back-in-stock-subscriptions', bisBody)
        .then((res) => {
          if (res.status !== 202) {
            return res.text().then((t) => {
              let d;
              try {
                const j = JSON.parse(t);
                if (j.errors && j.errors[0]) d = j.errors[0].detail || j.errors[0].title;
              } catch (x) {
                d = t ? t.slice(0, 100) : '';
              }
              showErr(d || 'Could not subscribe. Try again.');
            });
          }
          if (marketingCb && marketingCb.checked && listId) {
            klaviyoPost('subscriptions', {
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'PDP back in stock modal',
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email,
                        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                      },
                    },
                  },
                },
                relationships: { list: { data: { type: 'list', id: listId } } },
              },
            }).catch(() => {});
          }
          showSuccess();
        })
        .catch(() => {
          showErr('Could not reach Klaviyo. Check your connection and try again.');
        })
        .finally(() => {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtnOriginalText;
        });
    });
  });
})();
